var DEGREE = 180 / Math.PI;
var toDegree = function (radian) {
    return DEGREE * radian;
};
export default toDegree;
//# sourceMappingURL=to-degree.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.9@@antv/util/esm/to-degree.js
// module id = null
// module chunks = 